import axios from "axios";

const SUCCESS_CODES = [0, 200, "0", "200"];

const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "",
  withCredentials: true,
  withXSRFToken: true,
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
});

const getMessage = (payload, fallback = "请求失败") => {
  const message = payload?.message || payload?.msg || payload?.error;

  if (typeof message === "string" && message.trim()) {
    return message;
  }

  return typeof fallback === "string" && fallback.trim() ? fallback : "请求失败";
};

service.interceptors.response.use(
  (response) => {
    const payload = response.data;

    if (payload && typeof payload === "object" && "code" in payload) {
      if (!SUCCESS_CODES.includes(payload.code)) {
        return Promise.reject({
          ...payload,
          message: getMessage(payload),
        });
      }

      return Object.prototype.hasOwnProperty.call(payload, "data")
        ? payload.data
        : payload;
    }

    return payload;
  },
  (error) => {
    const payload = error.response?.data || {};
    const isLoginRequest = error.config?.url === "/auth/login";

    if (error.response?.status === 401 && !isLoginRequest) {
      window.dispatchEvent(new CustomEvent("moseycat:unauthorized"));
    }

    return Promise.reject({
      ...payload,
      status: error.response?.status,
      message: getMessage(payload, error.message),
      originalError: error,
    });
  },
);

export default service;
